import { useEffect } from 'react';

const useSetCssForAggridTable = (
  isNoCrossesFound: boolean
) => {
  useEffect(() => {
    const checkBox = document.querySelector('.ag-row-even.ag-row.ag-row-level-0.ag-row-position-absolute.ag-row-first > .ag-cell-wrap-text> .ag-cell-wrapper> .ag-selection-checkbox')
   
    if(isNoCrossesFound){
      checkBox?.classList.add('hideCheckBox')
    }else{
      checkBox?.classList.remove('hideCheckBox')
    }
    
  }, [isNoCrossesFound]);
};
export default useSetCssForAggridTable;
